export const LIVE_URL =
  "https://datingappbackend.innoventixsolutions.online/api/v2";
// export const LIVE_URL = "http://192.168.0.40:5000/api/v2";
